/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-23 15:16:21
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-22 14:23:51
 */

import { Space, TableColumnType, Tooltip } from 'antd'
import React, { ReactElement } from 'react'
import { getPlatformTypeName, getTenantCategoryName } from "../../../models/tenant";
import styles from '../monitoringTab.module.css'
export const UseColumns = (
  onClick: (t: any) => void,
  startIndex: number,
): TableColumnType<any>[] => {


  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '机构名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function element(_, t) {
        return t?.name ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={t.name}>
              <div className={styles.tableText}>{t.name}</div>
            </Tooltip>
            {t.insuranceStatus ? <div className={styles.textName}>保</div> : ''}
            {!t.openType ? <div className={styles.textName2}>煎</div> : ''}
          </div>
        ) : (
          '-'
        )
      },
    },
    {
      title: '机构类别',
      key: 'tenantCategory',
      dataIndex: 'tenantCategory',
      align: 'center',
      width: '5rem',
      ellipsis: true,
      render: (_, t) => getTenantCategoryName(t.tenantCategory),
    },
    {
      title: '机构类型',
      key: 'tenantType',
      dataIndex: 'tenantType',
      align: 'center',
      width: '12rem',
      ellipsis: true,
    },
    {
      title: '所属平台',
      dataIndex: 'platformType',
      key: 'platformType',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => getPlatformTypeName(t.platformType),
    },
    {
      title: '所在区域',
      dataIndex: 'address',
      key: 'address',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function element(_, t) {
        return t?.address || '-'
      },
    },
    {
      title: '患者数',
      dataIndex: 'patientNumber',
      key: 'patientNumber',
      align: 'center',
      width: '4rem',
      ellipsis: true,
    },
    {
      title: '门诊次数',
      dataIndex: 'outpatientNumber',
      key: 'outpatientNumber',
      align: 'center',
      width: '6rem',
      ellipsis: true,
    },
    {
      title: '结算笔数',
      dataIndex: 'settlementNumber',
      key: 'settlementNumber',
      align: 'center',
      width: '6rem',
      ellipsis: true,
    },
    {
      title: '结算金额',
      dataIndex: 'settlementMoney',
      key: 'settlementMoney',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => t.settlementMoney?.toFixed(2),
    },
    {
      title: '中药方金额',
      dataIndex: 'tcmMoney',
      key: 'tcmMoney',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => t.tcmMoney?.toFixed(2),
    },
    {
      title: '预约次数',
      dataIndex: 'appointmentNum',
      key: 'appointmentNum',
      align: 'center',
      width: '5rem',
      ellipsis: true,
    },
    {
      title: '代煎次数',
      dataIndex: 'potionNum',
      key: 'potionNum',
      align: 'center',
      width: '5rem',
      ellipsis: true,
    },
    {
      title: '前五疾病',
      dataIndex: 'discountNum',
      key: 'discountNum',
      align: 'center',
      width: '6rem',
      render: function element(_, t) {
        return (
          <Space>
            <a onClick={() => onClick(t)}>查看 </a>
          </Space>
        )
      },
    },
  ]
}
